<template>
    <div style="width: 100%">
        <AdminTools />
        <div class="flexContainer full what">
            <section id="sectionPrincipal">
                <section v-if="profile" class="brand-list">
                    <h1 class="center" style="font-size: 50px">{{ profile.name }}</h1>
                    <section class="searchResultsWrapper">
                        <AppSection
                            @changeRole="changeAccess"
                            v-for="app in getAllApplications"
                            :app="app"
                            :access="access"
                            :key="'function_' + app.id"
                        >
                        </AppSection>
                    </section>
                </section>
                <div class="functionBtn">
                    <div class="functionBtn">
                        <b-button-toolbar class="btnActionUser">
                            <button class="btn btn-dark uppercase" @click="$router.push({ path: `/admin/profiles` });">
                                {{ $t("common.cancel") }}
                            </button>
                            <button class="btn-dark btn uppercase" @click="save">{{ $t("common.save") }}</button>
                        </b-button-toolbar>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import TryLoad from "@/mixins/TryLoadMixin";
import AdminTools from "../../adminTools/Admin";
import AppSection from "@/components/admin/user/AppSection";
import userService from "@/services/user";
import { mapActions, mapGetters } from "vuex";

export default {
    data: () => ({
        access: [],
        profile: null,
        loading: false
    }),
    components: {
        AdminTools,
        AppSection
    },
    mixins: [TryLoad],
    async created() {
        await this.findAllApplications();
        this.profile = await this.tryLoad(() => userService.getProfileWithAccess(this.$route.params.id));
        this.access = this.profile.accessesProfile;
    },
    computed: {
        ...mapGetters({
            getAllApplications: "functionality/getAllApplications"
        })
    },
    methods: {
        ...mapActions({
            findAllApplications: "functionality/findAllApplications"
        }),
        changeAccess(accessChange) {
            this.access = accessChange;
        },
        async save() {
            try {
                await userService.updateProfileAccess(this.profile, this.access);
                this.dialogSuccess("success");
                this.$router.push({ path: `/admin/profiles` });
            } catch (e) {
                this.dialogError(e);
            }
        }
    }
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// ProfileRole.vue?5fda4698